import { useEffect, useRef, useState } from 'react'

/*
 * FinviseOrgFilter
 * Main-admin-only company filter for the Finvise Dashboard/Properties pages.
 * `selected` is an array of organisation ids, or an empty array meaning
 * "all companies". Same visual language as FinviseRangePicker (.range-*).
 */
const FinviseOrgFilter = ({ organisations = [], selected = [], onChange }) => {
	const [open, setOpen] = useState(false)
	const wrapRef = useRef(null)

	useEffect(() => {
		const onDoc = e => {
			if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false)
		}
		const onEsc = e => {
			if (e.key === 'Escape') setOpen(false)
		}
		document.addEventListener('click', onDoc)
		document.addEventListener('keydown', onEsc)
		return () => {
			document.removeEventListener('click', onDoc)
			document.removeEventListener('keydown', onEsc)
		}
	}, [])

	const allSelected = !selected || selected.length === 0
	const selectedOrg =
		!allSelected && selected.length === 1
			? organisations.find(o => o.id === selected[0])
			: null
	const label = allSelected
		? 'All companies'
		: selectedOrg
		? selectedOrg.name
		: selected.length + ' companies'

	const selectAll = () => {
		onChange([])
		setOpen(false)
	}

	const toggleOrg = id => {
		const base = allSelected ? [] : selected
		onChange(
			base.includes(id) ? base.filter(x => x !== id) : [...base, id],
		)
	}

	return (
		<div className='range-wrap' ref={wrapRef}>
			<button
				className='range-btn'
				aria-haspopup='true'
				aria-expanded={open}
				onClick={e => {
					e.stopPropagation()
					setOpen(!open)
				}}
			>
				<svg
					className='cal-ico'
					width='15'
					height='15'
					viewBox='0 0 24 24'
					fill='none'
					stroke='currentColor'
					strokeWidth='1.9'
					strokeLinecap='round'
					strokeLinejoin='round'
				>
					<path d='M3 21V7l9-4 9 4v14M9 21v-6h6v6M3 11h18' />
				</svg>
				<span className='preset-name'>{label}</span>
				<svg
					width='12'
					height='12'
					viewBox='0 0 24 24'
					fill='none'
					stroke='currentColor'
					strokeWidth='2.4'
					strokeLinecap='round'
				>
					<path d='m6 9 6 6 6-6' />
				</svg>
			</button>

			{open ? (
				<div className='range-pop org-filter-pop open' role='menu'>
					<button
						className={'row' + (allSelected ? ' selected' : '')}
						role='menuitemcheckbox'
						aria-checked={allSelected}
						onClick={selectAll}
					>
						<span>All companies</span>
						<span className='check'>{'✓'}</span>
					</button>
					<div className='org-filter-list'>
						{organisations.map(o => {
							const checked = !allSelected && selected.includes(o.id)
							return (
								<label className='org-filter-row' key={o.id}>
									<input
										type='checkbox'
										checked={checked}
										onChange={() => toggleOrg(o.id)}
									/>
									<span>{o.name}</span>
								</label>
							)
						})}
						{!organisations.length ? (
							<div className='org-filter-empty'>No companies found</div>
						) : null}
					</div>
				</div>
			) : null}
		</div>
	)
}

export default FinviseOrgFilter
